export default __webpack_public_path__ + "static/media/Journey2.70aa2876.png";